import React, { Component } from 'react';
import '../App.css';
import '../semantic/dist/semantic.min.css';
import { Container, Dropdown, Icon, Button, Divider, Segment, Dimmer, Loader, Modal, ModalContent, Popup, List, ListItem } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../App.js';
import YupikEntry from './YupikEntry.js';
import Recorder from './Recorder.js';
import {withRouter} from 'react-router';
import StickyMenu from './common/StickyMenu.js';
import {nounOptionsMVPossessors,colorsList, mvSubject4thPersonCalls, mvObject4thPersonCalls,nObject4thPersonCalls, nounOptionsMVPossessorsThe, mvSubjectOptionsWho, mvSubjectOptionsWhat, mvObjectOptionsWhom, mvObjectOptionsWhomAbl, mvObjectOptionsWhat, mvObjectOptionsWhatAbl,retrieveMoodEnglish, nounOptionsPossessorsNo4th, mvSubjectOptionsOnly2nd, nounOptionsNumbers, nounoptionsmodalis, mvSubjectOptions, mvObjectOptions, mvSubjectOptionsEnglish, verbPostbases, nounPostbases, VVpostbases, NNpostbases} from './constants/newconstants.js'
import { TagColors, WordItemLikeInup } from './SearchPageHelpers.js';

let customFontFam = "Roboto,'Helvetica Neue',Arial,Helvetica,sans-serif"
const options = [
  { key: 1, text: 'it', value: 1 },
  { key: 2, text: 'you', value: 2 },
]

let peopleDict = {
  '1':"Sg",
  '2':"Du",
  '3':"Pl",
}


let vOptions = [
  'vBase',
  'nsBases',
  'noBases',
  'no',
  'ns',
  'vMood',
  'vs',
  'vo',
  'nObliques',
  'qWord',
  'vType',
]

let nOptions = [
  'n',
  'nBases',
  'nCase',
  'nType',
]

let vEnglish = [
  'mvEnglish1',
  'mvEnglish2',
  'mvEnglish3',
  'mvEnglishAbl',
  'mvnsEnglish1',
  'mvnsEnglish2',
  'mvnoEnglish1',
  'mvnoEnglish2',
  'cvnsEnglish1',
  'cvnsEnglish2',
  'cvnoEnglish1',
  'cvnoEnglish2',
  'svnoEnglish1',
  'svnoEnglish2',
  'cvEnglish1',
  'cvEnglish2',
  'cvEnglish3',
  'cvEnglishAbl',
  'svEnglish1',
  'svEnglish2',
  'svEnglishAbl',
  'npnEnglish1',
  'npnEnglish2',
  'mvnObliquesEnglish1',
  'mvnObliquesEnglish2',
  'cvnObliquesEnglish1',
  'cvnObliquesEnglish2',
  'svnObliquesEnglish1',
  'svnObliquesEnglish2',
]



class SimpleWordBuilderUpdated extends Component {
  constructor(props) {
    super(props);
    console.log("SimpleWordBuilderUpdated props: ", props);
    // console.log(props.entry)
    // console.log(props.entry[5][0])
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const record = urlParams.get('record') 
    // console.log(urlParams, record)
    this.state = {
      showModal:false,
      mvEnglish1: [],
      mvEnglish2: [],
      mvEnglish3: [],
      mvEnglishAbl: [],
      mvvs:[],
      mvvo:[],
      mvvBase:[],
      mvvMood:"",
      mvvSegments:"",
      colorScheme:0,
      colorsList: {
        'mvv.b':'#000000',
        'mvv.e':'#852828',
        'mvv.s':'#852828',
        'mvv.o':'#961616',
        'mvv.m':'#838383',
        'mvv.1':'#3455b5',
        'mvv.2':'#d3741e',
        'mvv.3':'#c062c3',
        'mvv.4':'#008000',
        'mvv.5':'#69b4b4',
        'mvv.6':'#e02323',

        'npn00.b':'#000000',
        'npn00.1':'#e02323',
        'npn00.2':'#69b4b4',
        'npn00.pd':'#961616',
        'npn00.ps':'#852828',
        // 'mvns00.b':'#852828',
        // 'mvns00.1':'#b53434',
        // 'mvns00.2':'#578f7f',
        // 'mvns00.e':'#f29090',
        // 'mvns10.b':'#852828',
        // 'mvv.4':'#000000',
      },

      npnEnglish1: [],
      npnEnglish2: [],

      npn:[],
      npnBases:[],
      npnCase:[],
      npnSegments:[],
      npnType:[], 

      // mvSubjectOptions:mvSubjectOptions,
      // mvObjectOptions:mvObjectOptions,

      mvSubjectOptions1:mvSubjectOptions,
      mvObjectOptions1:mvObjectOptions,

      segmentString:props.entry[2],
      audioRetrieved:props.usageStartingAudio,

      openPopup:false,
      // entry:props.entry[2],
      audioParameterBool: record !== null || true ? true : false,
      englishString:'',
      playingAudio: false,
      clickedAudioUrl: "",
      clickedAudio: null,
      clickedAudioIndex:-1,
    }
  }

  componentDidMount() {
    // backEndCall()
    // console.log(this.props)
    let initializedCall
    if (this.props.entry[0] == 'n') {
      initializedCall = [["Insert",["np"],[[[this.props.word,0,this.props.index,this.props.definitionIndex]],[0,0,0,1],"Abs"]]]
    } else {
      initializedCall = [["Insert",["mv"],[[[this.props.word,0,this.props.index,0]],this.props.entry[0],"Ind"]]]
    }

    // [["Insert", ["mv"], [[["nere-", 0, 0, 0]], "i", "Ind"]]]]
    this.backEndCall(initializedCall, true)
  }

  componentWillReceiveProps(nextProps) {
    // backEndCall()
    // console.log(nextProps)
    let initializedCall
    if (nextProps.entry[0] == 'n') {
      initializedCall = [["Insert",["np"],[[[nextProps.word,0,nextProps.index,nextProps.definitionIndex]],[0,0,0,1],"Abs"]]]
    } else {
      initializedCall = [["Insert",["mv"],[[[nextProps.word,0,nextProps.index,0]],nextProps.entry[0],"Ind"]]]
    }

    // [["Insert", ["mv"], [[["nere-", 0, 0, 0]], "i", "Ind"]]]]
    this.backEndCall(initializedCall, true)
  }


  backEndCall(keyChanged, eraseExisting) {
    // console.log('backend',this.state)
    // console.log(keyChanged)

    let mv = {}
    let cv = {}
    let sv = {}
    let np = {}

    if (eraseExisting) {

    } else {
      if (this.state.mvvBase.length > 0) {mv['vBase']=this.state.mvvBase}

      if (this.state.mvvMood.length > 0) {mv['vMood']=this.state.mvvMood}
      if (this.state.mvvs.length > 0) {mv['vs']=this.state.mvvs}
      if (this.state.mvvo.length > 0) {mv['vo']=this.state.mvvo}

      if (this.state.npn.length > 0) {np['n']=this.state.npn}
      if (this.state.npnBases.length > 0) {np['nBases']=this.state.npnBases}
      if (this.state.npnCase.length > 0) {np['nCase']=this.state.npnCase}

    }

    // console.log(keyChanged,mv)
    axios
      .post(API_URL + "/sentencebuilder", {
        keyChanged:keyChanged,
        mv:mv,
        cv:cv,
        sv:sv,
        np:np,
      })
      .then(response => {
        console.log('backend',response.data)
        let vkey, nkey
        let updateDict = {}
        if ("english" in response.data) {
          vEnglish.map((k)=>{
            if (k in response.data['english']) {
              updateDict[[k]] = response.data['english'][k]
            } else {
              updateDict[[k]] = []
            }
          })

        }

        if ("mv" in response.data) {
          updateDict['mv'] = response.data['mv']
          vOptions.map((k)=>{
            vkey = 'mv'+k
            if (k in response.data['mv']) {
              // this.setState({
                // [vkey]: response.data['mv'][k],
              // })

              updateDict[[vkey]] = response.data['mv'][k]
              // if (k == 'qWord') {
              //  updateDict[['interCase']] = response.data['mv'][k][0]           
              // }
            } else {

              updateDict[[vkey]] = []

              // this.setState({
                // [vkey]: [],
              // })             
            }
          })
        } else {
          this.initialize('mv')
        }

        if ("np" in response.data) {
          updateDict['np'] = response.data['np']

          nOptions.map((k)=>{
            nkey = 'np'+k
            if (k in response.data['np']) {
              updateDict[[nkey]] = response.data['np'][k]
            } else {
              updateDict[[nkey]] = []           
            }
          })
        } else {
          this.initialize('np')
        }

        // let segmentString = ''
        if ("segments" in response.data) {
          if ("mv" in response.data.segments) {
            if ("v" in response.data.segments.mv) {
              // this.setState({
                // mvvSegments: response.data.segments.mv.v,
              // })
              // response.data.segments.mv.v.map((t)=>{segmentString+=t[0]})
              updateDict['mvvSegments'] = response.data.segments.mv.v
              // updateDict['segmentString'] = segmentString
            } else {
              // this.setState({
                // mvvSegments: "",
              // })                     
              updateDict['mvvSegments'] = ""
            }       
          }

          if ("np" in response.data.segments) {
            if ("n" in response.data.segments.np) {
              // this.setState({
                // npnSegments: response.data.segments.np.n,
              // })             
              // response.data.segments.np.n[0][0].map((t)=>{segmentString+=t[0]})
              updateDict['npnSegments'] = response.data.segments.np.n
              // updateDict['segmentString'] = segmentString
            } else {
              // this.setState({
                // npnSegments: [],
              // })                     
              updateDict['npnSegments'] = []
            }
          }
        }

        updateDict['segmentString']=response.data.segmentString
        updateDict['audioRetrieved']=response.data.audioRetrieved
        let englishString = ''
        if ("mvEnglishString" in response.data.english) {
          englishString+=response.data.english.mvEnglishString
        }
        if ("cvEnglishString" in response.data.english) {
          englishString+=' '+response.data.english.cvEnglishString
        }
        if ("svEnglishString" in response.data.english) {
          englishString+=' '+response.data.english.svEnglishString
        }
        if ("npEnglishString" in response.data.english) {
          englishString+=' '+response.data.english.npEnglishString
        }
        updateDict['englishString']=englishString


        this.setState(updateDict)



      })

  }


  componentDidUpdate(prevProps, prevState) {
    if (prevState.mv !== this.state.mv || prevState.np !== this.state.np) {
      this.updateAllowableOptions()
    }

    // if (prevState.segmentString !== this.state.segmentString) {
    //   console.log(this.state.segmentString)
    //   this.displayIfClipExists(this.state.segmentString)
    // }

  }

  updateAllowableOptions = () => {

    let mvSubjectOptions1 = []
    let mvObjectOptions1 = []
    // let nounOptionsSVPossessors1 
    // let nounOptionsCVPossessors1 
    // let nounOptionsMVPossessors1 
    // let nounOptionsCVAblPossessors1
    // let nounOptionsMVAblPossessors1 
    // let nounOptionsSVAblPossessors1

    if (this.state.mvvs.length > 0 && this.state.mvvo.length > 0) {
      if (this.state.mvvs[0] == 1) {
        mvObjectOptions.map((k)=>{
          if (![0,6,10].includes(k['id'])) {
            mvObjectOptions1 = mvObjectOptions1.concat(k)
          }
        })
      } else if (this.state.mvvs[0] == 2) {
        mvObjectOptions.map((k)=>{
          if (![1,7,11].includes(k['id'])) {
            mvObjectOptions1 = mvObjectOptions1.concat(k)
          }
        })
      } else {
        mvObjectOptions1 = mvObjectOptions
      }

      if (this.state.mvvo[0] == 1) {
        mvSubjectOptions.map((k)=>{
          if (![0,6,10].includes(k['id'])) {
            mvSubjectOptions1 = mvSubjectOptions1.concat(k)
          }
        })
      } else if (this.state.mvvo[0] == 2) {
        mvSubjectOptions.map((k)=>{
          if (![1,7,11].includes(k['id'])) {
            mvSubjectOptions1 = mvSubjectOptions1.concat(k)
          }
        })
      } else {
        mvSubjectOptions1 = mvSubjectOptions
      }
      
    } else {
      mvSubjectOptions1 = mvSubjectOptions
    }

    this.setState({
      mvSubjectOptions1:mvSubjectOptions1,
      mvObjectOptions1:mvObjectOptions1,
    })
    
  }

  recordClip = (sentence, siteLocation,english) => {
        return <Modal
            on='click'
            open={this.state.showModal}
            style={{
              maxWidth:500,
              marginTop:(window.innerWidth < 480 ? 10 : 10),
            }}
            closeOnDimmerClick={false}
            onOpen={()=>{
            }}
            onClose={()=>{
              console.log('modal closing?')
              this.setState({showModal:false,wordsList:[],searchQuery:''})
            }}
          >
          <ModalContent>
            <Icon circular style={{margin:0,color:'#929292',cursor:'pointer',position:'relative',float:'right'}} size='large' onClick={()=>{this.setState({showModal:false});}} name='x' />
            <Recorder english={english} sentence={sentence} siteLocation={siteLocation} />          
          </ModalContent>
          </Modal>
  }

  displayIfClipExists = (sentence) => {
    // console.log(sentence)
    // axios
    //   .get(API_URL + "/yugtunCrowdsourceAudioLookup/" + sentence)
    //   .then(response => {
    //     // console.log(response.data);
    //     this.setState({audioRetrieved:response.data})
    //   });
  }

  displayAudioMic = (audioRetrieved) => {
    return <Popup
            content={
              <List style={{fontFamily:customFontFam}} divided verticalAlign='middle'>
                {audioRetrieved.map((k,kindex)=>{
                  return <ListItem style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                          <Button style={{float:'left', border:(this.state.playingAudio && this.state.clickedAudioIndex === kindex ? 'solid 1px #4a80b5' : 'solid 1px #dededf'),marginLeft:5,backgroundColor:'white', color:(k['village'] == 'computer generated' ? '#929292' : '#106181'),cursor:'pointer'}} circular icon='volume up' onClick={()=>this.repeatAudio(k['filename'], kindex)} />
                          <div style={{display:'flex',flexDirection:'column',marginLeft:10,padding:'5px 0px'}}>
                            {k['gender'] != 'do_not_wish_to_say' ?
                              <div>{k['gender'].replaceAll('_',' / ')}</div>
                              :
                              null
                            }
                            {k['age'] != 'do_not_wish_to_say' ?
                              <div>{k['age']}</div>
                              :
                              null
                            }
                            {k['village'] != 'do_not_wish_to_say' ?
                              <div>{k['village']}</div>
                              :
                              null
                            }
                            {(k['gender'] == 'do_not_wish_to_say' || k['gender'] == '') && (k['age'] == 'do_not_wish_to_say' || k['age'] == '') && (k['village'] == 'do_not_wish_to_say' || k['village'] == '') ?
                              <div>{'Anonymous'}</div>
                              :
                              null
                            }                            
                          </div>
                        </ListItem>
                })}
                <ListItem style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                  <Button circular basic style={{opacity:0.9,marginLeft:5,fontSize:'14px'}} onClick={()=>{this.setState({openPopup:false},()=>{this.setState({showModal:true})})}} icon='microphone' />
                  <div style={{marginLeft:10,padding:'5px 0px'}}>Submit a Recording for Yugtun.com</div>
                </ListItem>
              </List>
              }
            on='click'
            open={this.state.openPopup}
            onClose={()=>this.setState({openPopup:false})}
            style={{padding:8}}
            position='bottom center'
            trigger={<Button onClick={()=>{this.setState({openPopup:true})}} style={{paddingRight:15, marginLeft:10}} circular basic icon>{audioRetrieved.length == 0 ? <Icon style={{color:'#929292'}} name='microphone' /> : (audioRetrieved.length == 1 && audioRetrieved[0]['village'] == 'computer generated' ? <Icon style={{color:'#929292',fontSize:'16px'}} name='volume up' /> : <Icon style={{color:'#106181',fontSize:'16px'}} name='volume up' />)}<Icon style={{color:'#d2d2d2',paddingLeft:'6px',fontSize:'11px'}} name='chevron down' /> </Button>}
          />
  }

  // repeatAudio(audio, event, data) {
  //   // console.log(audio)
  //   if (!this.state.playingAudio) {

  //     let sound = new Audio(API_URL + "/yugtunCrowdsourceAudio/" + audio);
  //     this.setState({playingAudio: true});

  //     sound.play()

  //     sound.onended=()=>{
  //       this.setState({playingAudio: false});
  //     }
  //   }
  // }

  repeatAudio(audio, index, event, data) {

    let audioURL = API_URL + "/yugtunCrowdsourceAudio/" +  audio;

    // stop audio on double click
    if (this.state.playingAudio === true && this.state.clickedAudioUrl === audioURL) {
      let audio = this.state.clickedAudio;
      audio.pause();
      audio.currentTime = 0;
      this.setState({clickedAudio:audio, clickedAudioIndex:-1, playingAudio: false})
    }

    // stop first audio then play new one
    if (this.state.playingAudio === true && this.state.clickedAudioUrl !== audioURL) {
      let firstAudio = this.state.clickedAudio;
      firstAudio.pause();
      firstAudio.currentTime = 0;

      this.setState({playingAudio: true});
      let secondAudio = new Audio(audioURL);
      secondAudio.play();
      this.setState({clickedAudioUrl:audioURL,  clickedAudioIndex:index, clickedAudio:secondAudio})
      secondAudio.onended=()=>{this.setState({playingAudio: false,clickedAudioIndex:-1,})};
    }

    // play audio again
    if (this.state.playingAudio === false && this.state.clickedAudioUrl === audioURL) {
      let audio = this.state.clickedAudio;
      this.setState({playingAudio: true,  clickedAudioIndex:index, });
      audio.play();
      audio.onended=()=>{this.setState({playingAudio: false,clickedAudioIndex:-1,})};
    }

    // play new audio
    if (this.state.playingAudio === false && this.state.clickedAudioUrl !== audioURL) {
      this.setState({playingAudio: true});
      let audio = new Audio(audioURL);
      audio.play();
      this.setState({clickedAudioUrl:audioURL, clickedAudioIndex:index, clickedAudio:audio})
      audio.onended=()=>{this.setState({playingAudio: false,clickedAudioIndex:-1,})};
    }

  }

  render() {
    console.log(this.state.englishString)

    // console.log(mvSubjectOptions)
    // console.log(mvObjectOptions)

    // let numEntries = Object.keys(this.state.fullWord).filter((entryNumber) => {
    //   return entryNumber !== 'english' && entryNumber !== 'yupik';
    // }).length;
    let newWord = '';
    return (
      <div>
      {this.state.npnSegments.length === 0 && this.state.mvvBase.length === 0 ?
        <Segment basic style={{height:171}} />     
        :
        null
      }

      {this.state.mvvBase.length > 0 && this.state.mvvSegments.length > 0 ?
        <div style={{marginTop:'13px', marginBottom:'20px',marginLeft:'15px'}}>
        <div style={{marginBottom:10,fontSize:'22px',color:'#000000',fontWeight:'400'}}>
          <div style={{cursor:'pointer',lineHeight:'35px',marginLeft:'2px'}}>
            {this.state.mvvSegments.map((t)=>
              <span style={{color:colorsList[this.state.colorScheme][t[1]]}}>{t[0]}</span>
            )}
            {this.state.audioParameterBool ?
              this.displayAudioMic(this.state.audioRetrieved)
              :
              null
            }
            {this.state.showModal ?
              this.recordClip(this.state.segmentString,'entryUsage',this.state.englishString)
              :
              null
            }
          </div>
        </div>

        <div style={{marginTop:'10px', marginBottom:'20px',fontSize:'18px',color:'#0D0D0D',fontWeight:'300'}}>          
        {this.state.mvEnglish1.map((w,wind)=>{
          return <span style={{color:colorsList[this.state.colorScheme][w[1]]}}>{w[0]+" "}</span>
        })}
        {this.state.mvvs.length > 0 ?
          <Dropdown inline scrolling style={{border:'solid 1px #22242626',color:'#852828',fontSize:'18px',padding:'5px',borderRadius:'5px',marginRight:'4px'}} onChange={(event,data)=>{this.backEndCall([["Update",["mv","vs"],data.value.split('').map(Number)]])}}  value={this.state.mvvs.join("")} options={this.state.mvSubjectOptions1} />
          :
          null
        }
        {this.state.mvEnglish2.map((w,wind)=>{
          return <span style={{color:colorsList[this.state.colorScheme][w[1]]}}>{w[0]+" "}</span>
        })}   

        {this.state.mvvo.length > 0 ?
          (this.state.mvvBase[1] == 'it' ?
            (this.state.mvEnglishAbl.map((w,wind)=>
              <span style={{color:colorsList[this.state.colorScheme][w[1]]}}>{w[0]}</span>
            ))
            :
            <Dropdown inline scrolling style={{border:'solid 1px #22242626',color:'#c84141',fontSize:'18px',padding:'5px',borderRadius:'5px',marginRight:'4px'}} onChange={(event,data)=>{this.backEndCall([["Update",["mv","vo"],data.value.split('').map(Number)]])}}  value={this.state.mvvo.join("")} options={this.state.mvObjectOptions1} />
          )
          :
          null
        }

        {this.state.mvEnglish3.map((w,wind)=>{
          return <span style={{marginLeft:(this.state.mvvo.length > 0 ? (this.state.mvvBase[1] == 'it' ? '4px' : '0px') :'0px')}}>
                  <span style={{color:colorsList[this.state.colorScheme][w[1]]}}>{w[0]+" "}</span>
                </span>
        })}
        </div>

        <div style={{}}>
        <Link to={{pathname: '/sentencebuilder/2', state: { mv: this.state.mv }}}>
          <Button basic compact style={{fontSize:'16px',fontWeight:'300'}}>
          <div style={{display:'flex',flexDirection:'column',fontFamily:customFontFam}}>
          Try Word Builder
          </div>
          </Button>
        </Link>
        </div>

        </div>
        :
        null
      }


      {this.state.npnSegments.length > 0 && this.state.npnSegments.length === this.state.npn.length ?
        <div style={{marginTop:'13px', marginBottom:'20px',marginLeft:'15px'}}>
          <div style={{marginBottom:10,fontSize:'22px',fontWeight:'400'}}>
            <div style={{lineHeight:'35px',marginLeft:'2px'}}>

              {this.state.npnSegments.slice().reverse()[0][0].map((t)=>
                <span style={{color:colorsList[this.state.colorScheme][t[1]]}}>{t[0]}</span>
              )}
              {this.state.audioParameterBool ?
                this.displayAudioMic(this.state.audioRetrieved)
                :
                null
              }
              {this.state.showModal ?
                this.recordClip(this.state.segmentString,'entryUsage',this.state.englishString)
                :
                null
              }
            </div>
          </div>



          <span>
            <div style={{marginTop:'10px', marginBottom:'20px',fontSize:'18px',color:'#0D0D0D',fontWeight:'300'}}>          
            {this.state.npnEnglish1.map((w,wind)=>
              <span style={{color:colorsList[this.state.colorScheme][w[1]]}}>{w[0]+" "}</span>
              )}
            <Dropdown inline scrolling style={{border:'solid 1px #22242626',color:'#5c5c5c',fontSize:'18px',padding:'5px',borderRadius:'5px',marginRight:'4px'}} onChange={(event,data)=>{this.backEndCall([["Update",["np","n",this.state.npnSegments.length-1,0],(data.value+this.state.npn[this.state.npnSegments.length-1][0].slice(-1).toString()).split('').map(Number)]])}} value={this.state.npn[this.state.npnSegments.length-1][0].slice(0, -1).join("")} options={nounOptionsMVPossessorsThe} />
            <Dropdown inline scrolling style={{border:'solid 1px #22242626',color:'#852828',fontSize:'18px',padding:'5px',borderRadius:'5px',marginRight:'4px'}} onChange={(event,data)=>{this.backEndCall([["Update",["np","n",this.state.npnSegments.length-1,0],this.state.npn[this.state.npnSegments.length-1][0].slice(0, -1).concat(data.value.split('').map(Number))]])}} value={this.state.npn[this.state.npnSegments.length-1][0].slice(-1).join("")} options={nounOptionsNumbers} />                                
            {this.state.npnEnglish2[0].map((w,wind)=>
              (w.map((t)=> <span style={{color:colorsList[this.state.colorScheme][t[1]]}}>{t[0]+" "}</span>))
              )}
            </div>
          </span>

          <div style={{}}>
          <Link to={{pathname: '/sentencebuilder/2', state: { np: this.state.np }}}>
            <Button basic compact style={{fontSize:'16px',fontWeight:'300'}}>
            <div style={{display:'flex',flexDirection:'column',fontFamily:customFontFam}}>
            Try Word Builder
            </div>
            </Button>
          </Link>
          </div>
        </div>

          :
          null
      }



      </div>
    );
  }
}

export default withRouter(SimpleWordBuilderUpdated);



// WEBPACK FOOTER //
// ./src/components/SimpleWordBuilderUpdated.js